var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreHorizontalIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 4,
    viewBox: "0 0 14 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66666 2.00016C1.66666 2.17697 1.73689 2.34654 1.86192 2.47157C1.98694 2.59659 2.15651 2.66683 2.33332 2.66683C2.51013 2.66683 2.6797 2.59659 2.80473 2.47157C2.92975 2.34654 2.99999 2.17697 2.99999 2.00016C2.99999 1.82335 2.92975 1.65378 2.80473 1.52876C2.6797 1.40373 2.51013 1.3335 2.33332 1.3335C2.15651 1.3335 1.98694 1.40373 1.86192 1.52876C1.73689 1.65378 1.66666 1.82335 1.66666 2.00016Z",
    stroke: "#354052",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33332 2.00016C6.33332 2.17697 6.40356 2.34654 6.52859 2.47157C6.65361 2.59659 6.82318 2.66683 6.99999 2.66683C7.1768 2.66683 7.34637 2.59659 7.47139 2.47157C7.59642 2.34654 7.66666 2.17697 7.66666 2.00016C7.66666 1.82335 7.59642 1.65378 7.47139 1.52876C7.34637 1.40373 7.1768 1.3335 6.99999 1.3335C6.82318 1.3335 6.65361 1.40373 6.52859 1.52876C6.40356 1.65378 6.33332 1.82335 6.33332 2.00016Z",
    stroke: "#354052",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2.00016C11 2.17697 11.0702 2.34654 11.1953 2.47157C11.3203 2.59659 11.4898 2.66683 11.6667 2.66683C11.8435 2.66683 12.013 2.59659 12.1381 2.47157C12.2631 2.34654 12.3333 2.17697 12.3333 2.00016C12.3333 1.82335 12.2631 1.65378 12.1381 1.52876C12.013 1.40373 11.8435 1.3335 11.6667 1.3335C11.4898 1.3335 11.3203 1.40373 11.1953 1.52876C11.0702 1.65378 11 1.82335 11 2.00016Z",
    stroke: "#354052",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreHorizontalIcon);
export default __webpack_public_path__ + "static/media/more-horizontal-icon.0d2565da9499332fc3ef3314a4aa8007.svg";
export { ForwardRef as ReactComponent };